declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      API_URL?: string;
      STATUSPAGE_URL?: string;
      STATUSPAGE_CNAME_TARGET?: string;
      GOOGLE_CLIENT_ID?: string;
      SENTRY_DSN?: string;
    };
  }
}

export const API_URL =
  window.__RUNTIME_CONFIG__?.API_URL ||
  import.meta.env.VITE_API_URL ||
  "http://localhost:3001";

export const STATUSPAGE_URL =
  window.__RUNTIME_CONFIG__?.STATUSPAGE_URL ||
  import.meta.env.VITE_STATUSPAGE_URL ||
  "http://localhost:3002";

export function getStatusPageUrl(slug: string, customDomain?: string | null): string {
  if (customDomain) {
    return `https://${customDomain}`;
  }
  const hostname = new URL(STATUSPAGE_URL).hostname;
  if (hostname === "localhost") {
    return `${STATUSPAGE_URL}/${slug}`;
  }
  return `https://${slug}.${hostname}`;
}

// The CNAME target customers must point their custom status page domain at.
// Used by the dashboard custom-domain settings to render the exact instruction
// string. Must stay in sync with the server-side STATUSPAGE_CNAME_TARGET so
// verification and instructions agree. Injected at build time (Vite env) with
// a runtime override hook for the Docker entrypoint.
export const STATUSPAGE_CNAME_TARGET =
  window.__RUNTIME_CONFIG__?.STATUSPAGE_CNAME_TARGET ||
  import.meta.env.VITE_STATUSPAGE_CNAME_TARGET ||
  "apex.status.watchplane.com";

export const GOOGLE_CLIENT_ID =
  window.__RUNTIME_CONFIG__?.GOOGLE_CLIENT_ID ||
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  "";
